module.exports = __webpack_public_path__ + "img/linked-in-info.54dcaf85.png";